export default __webpack_public_path__ + "static/small-image-norsk-4-38665f3ac046214cfd74e7abc927abf1.png";